import React from 'react';
import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';
import { Card } from '../ui/Card';

interface MetricCardProps {
  title: string;
  value: string | number;
  change?: number | null;
  icon: LucideIcon;
  onClick?: () => void;
  subtitle?: React.ReactNode;
  warningText?: string;
  /** Sufijo de la variación (ej. `'%'`, `' p.p.'`). */
  changeUnit?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  icon: Icon,
  onClick,
  subtitle,
  warningText,
  changeUnit = '%',
}) => {
  const showChange = change !== undefined && change !== null;
  const isPositive = showChange && change >= 0;

  return (
    <Card onClick={onClick} className="hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-600 mb-1">{title}</p>
          <p className="text-2xl font-bold text-primary mb-2">{value}</p>
          {subtitle != null && subtitle !== '' && (
            <p className="text-xs text-gray-500 mb-2">{subtitle}</p>
          )}
          {warningText != null && warningText !== '' && (
            <p className="text-xs text-amber-600 mb-2">{warningText}</p>
          )}
          {showChange && (
            <div className="flex items-center space-x-1">
              {isPositive ? (
                <TrendingUp className="w-4 h-4 text-green-500" />
              ) : (
                <TrendingDown className="w-4 h-4 text-red-500" />
              )}
              <span className={`text-sm font-medium ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
                {Math.abs(change)}
                {changeUnit}
              </span>
              <span className="text-sm text-gray-500">vs período anterior</span>
            </div>
          )}
        </div>
        <div className="p-3 bg-primary/10 rounded-lg">
          <Icon className="w-6 h-6 text-primary" />
        </div>
      </div>
    </Card>
  );
};

